import { render, staticRenderFns } from "./BookingStatusLabel.vue?vue&type=template&id=4d152430&scoped=true"
import script from "./BookingStatusLabel.vue?vue&type=script&lang=ts"
export * from "./BookingStatusLabel.vue?vue&type=script&lang=ts"
import style0 from "./BookingStatusLabel.vue?vue&type=style&index=0&id=4d152430&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d152430",
  null
  
)

export default component.exports